import React from 'react';
import styled from 'styled-components';



function Footer() {
  return (
      <footer>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <A href="http://compbio.utep.edu/privacy-policy/">Privacy Policy</A>
                </div>
              </div>
            </div>

              <div className="container">
                  <div className="row">
                      <div className="col-md-8 col-sm-7">
                          <div className="copyright">
                              <P>Copyright © Lin Li Lab. All Rights Reserved.</P>
                          </div>
                      </div>
                      <div className="col-md-4 col-sm-5">
                          <div className="social-icons">
                              <a href="/" className="facebook"><span class="iconify" data-icon="zmdi-facebook" data-inline="false"></span></a>
                              <a href="/" className="twitter"><span class="iconify" data-icon="logos:twitter" data-inline="false"></span></a>
                              <a href="/" className="linkedin"><span class="iconify" data-icon="typcn:social-linkedin" data-inline="false"></span></a>
                              <a href="/" className="pinterest"><span class="iconify" data-icon="jam:pinterest" data-inline="false"></span></a>
                          </div>
                      </div>
                  </div>
              </div>
          </footer>
  );
}


const A = styled.a`
    float:right;
    font-family:'Fira Sans';
`;

const P = styled.p`
    font-family:'Fira Sans';
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js